module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0078.jpg?v=ab8226ca";